/**
 * Toast — spec §F2 ("bottom-centre dark pill, 3.4 s, single instance").
 * The mockup keeps one `#toast` node in the DOM and toggles `.show`; this does the
 * same so the CSS transition is identical. State/timer live in lib/toast.ts.
 */
import { useToastStore } from '../lib/toast';

export function Toast() {
  const message = useToastStore((s) => s.message);
  return (
    <div id="toast" className={message ? 'show' : ''} role="status" aria-live="polite">
      {message ?? ''}
    </div>
  );
}
